"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
function ProgressBar(options) {
    var data = options.data, name = options.name, _a = options.max, max = _a === void 0 ? 24 : _a, _b = options.unit, unit = _b === void 0 ? "" : _b, _c = options.itemColor, itemColor = _c === void 0 ? "#80DECF" : _c, _d = options.barwidth, barwidth = _d === void 0 ? 9 : _d, _e = options.backgroundColor, backgroundColor = _e === void 0 ? "#F2F3F5" : _e, _f = options.labelColor, labelColor = _f === void 0 ? "#1D2129" : _f, _g = options.nameColor, nameColor = _g === void 0 ? "#86909C" : _g;
    return {
        xAxis: {
            type: "value",
            max: max,
            show: false
        },
        yAxis: {
            type: "category",
            position: "right",
            axisLine: {
                show: false
            },
            splitLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: true,
                color: labelColor,
                align: "right",
                margin: 64,
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "DINBold",
                formatter: function (value, index) {
                    return data[index] + " " + unit;
                }
            }
        },
        grid: {
            left: 0,
            right: 64,
            top: 0,
            bottom: 0
        },
        series: [
            {
                type: "bar",
                barMaxWidth: barwidth,
                itemStyle: {
                    color: itemColor,
                    borderRadius: 10,
                    opacity: 1
                },
                showBackground: true,
                backgroundStyle: {
                    color: backgroundColor,
                    borderRadius: 10
                },
                data: data,
                label: {
                    show: true,
                    position: [0, -20],
                    color: nameColor,
                    formatter: function (params) {
                        if (name) {
                            var labelName = name[params.dataIndex];
                            return labelName;
                        }
                        else {
                            return "";
                        }
                    }
                }
            }
        ]
    };
}
exports.ProgressBar = ProgressBar;
//# sourceMappingURL=ProgressBar.js.map